import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const MODUL = [
  { k: "umkm", l: "PPh Final 0,5% UMKM (Metode Pencatatan)", d: "Tab L-3B A (omzet bulanan) & L-2 A (penghasilan final)" },
  { k: "pph21", l: "PPh Pasal 21 (Gaji/Honor dari Pekerjaan/Direktur)", d: "Tab L-1 D (penghasilan dari pekerjaan) & L-1 E (bukti potong)" },
  { k: "pembukuan", l: "Pembukuan Formal (Neraca & Laba Rugi)", d: "Tab L-3A-2 (rekonsiliasi laporan keuangan)" },
];

export function PajakModulDialog({ user, onClose, onSaved }) {
  const [val, setVal] = useState({ umkm: false, pph21: false, pembukuan: false, ...(user?.pajak_modul || {}) });
  const save = async () => {
    try { await api.put(`/users/${user.id}/pajak-modul`, val); toast.success("Modul pajak disimpan"); onSaved(); onClose(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sa-pajak-dialog">
        <DialogHeader><DialogTitle>Modul Pajak — {user?.name || user?.email}</DialogTitle></DialogHeader>
        <p className="text-[12px] text-slate-500">L-1 A, L-1 B & L-2 B selalu tampil di Asisten SPT Coretax.</p>
        <div className="space-y-3">
          {MODUL.map((m) => (
            <label key={m.k} className="flex items-start justify-between gap-3 rounded-md border border-slate-200 p-3 cursor-pointer">
              <span><span className="block text-sm font-medium">{m.l}</span><span className="block text-[11px] text-slate-500">{m.d}</span></span>
              <Switch checked={val[m.k]} onCheckedChange={(c) => setVal({ ...val, [m.k]: c })} data-testid={`sa-pajak-${m.k}`}/>
            </label>
          ))}
        </div>
        <DialogFooter data-dialog-footer><Button variant="outline" onClick={onClose}>Batal</Button><Button onClick={save} data-testid="sa-pajak-save">Simpan</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
